import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { BaseComponent } from '../../components/base/base.component';
import { TextResourceService } from '../../services/text-resource.service';
import { WindowRef } from '../../services/window-ref.service';
import { AdvieswijzerService } from '../advieswijzer.service';
import { Answer } from '../models/answer';
import { Question } from '../models/question';
import { QuestionComponent } from './question/question.component';
import { ProgressBarComponent } from '@cibg/ui-components';

@Component({
    selector: 'app-question-list',
    templateUrl: './question-list.component.html',
    imports: [QuestionComponent, ProgressBarComponent]
})
export class QuestionListComponent extends BaseComponent implements OnInit, OnDestroy {
  @Input() questions: Question[] = [];

  maximumQuestionsLeftText: string;
  maximumQuestionsLeftScreenReaderText: string;
  maxQuestionsLeftPercentage = 0;
  currentQuestion: Question;
  currentAnswer: Answer;

  private $sub: Subscription;

  constructor(
    textResourceService: TextResourceService,
    private readonly windowRef: WindowRef,
    private readonly advieswijzerService: AdvieswijzerService) {
    super(textResourceService, 'QuestionComponent');
  }

  ngOnInit() {
    let firstQuestion = true;
    this.$sub = this.advieswijzerService.currentQuestionChanges
      .subscribe(cQ => {
        this.currentQuestion = cQ.q;
        this.currentAnswer = cQ.a;
        this.updateMaximumQuestionsLeftText();
        this.windowRef.scrollToElement('list-question-wrapper', !firstQuestion);
        firstQuestion = false;
      });
  }

  ngOnDestroy(): void {
    this.$sub.unsubscribe();
  }

  private updateMaximumQuestionsLeftText() {
    const maxQuestionsLeftNumber = this.currentQuestion.maxQuestionsLeft;
    this.maxQuestionsLeftPercentage = this.determinePercentage(this.currentQuestion.maxQuestionsLeft);

    this.maximumQuestionsLeftText = maxQuestionsLeftNumber === 1
      ? this.resources.maximumOneQuestionLeft
      : this.resources.maximumQuestionsLeft.replace('{0}', maxQuestionsLeftNumber.toString());
    this.maximumQuestionsLeftScreenReaderText = this.resources.maximumQuestionsLeftScreenReader
      .replace('{0}', this.maxQuestionsLeftPercentage.toString());
  }

  private determinePercentage(maxQuestionsLeftNumber: number) {
    switch (maxQuestionsLeftNumber) {
      case 1:
        return 90;
      case 2:
        return 70;
      case 3:
        return 60;
      case 4:
        return 50;
      case 5:
        return 40;
      case 6:
        return 30;
      case 7:
        return 10;
      case 8:
        return 0;
    }
    return 0;
  }
}
